import { render, staticRenderFns } from "./ai_catalog_list_skeleton.vue?vue&type=template&id=45b35bae"
import script from "./ai_catalog_list_skeleton.vue?vue&type=script&lang=js"
export * from "./ai_catalog_list_skeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports